import { Rect } from '../../../../foundation/geometry/rect';

import React, { useEffect, useState } from 'react';
import { When } from 'react-if';
import { ImmerFuncs } from '../../../../external/immer/immer.funcs';
import { PopupControllerStyle } from './popup-controller.style';
import { PopupEffect } from './popup-effect';
import { PopupEffectApi } from './popup-effect.api';
import { PopupPosition } from './popup-position';

type PopupItem = {
  component: React.ReactNode;
  triggerRect: Rect;
  positions: PopupPosition[];

  key: string;
};

export function PopupController({ apiRef }: { apiRef: React.MutableRefObject<PopupEffectApi> }) {
  const [items, setItems] = useState<PopupItem[]>([]);

  useEffect(() => {
    apiRef.current = {
      push: ({ component, triggerRect, positions }) => {
        const newItems = ImmerFuncs.produce(items, (draft) => {
          draft.push({ component, triggerRect, positions, key: Math.random().toString() });
        });
        setItems(newItems);
      },
      pop: () => {
        setItems(items.slice(0, -1));
      },
    };
  }, []);

  return (
    <div>
      <When condition={items.length > 0}>
        <PopupControllerStyle.Mask
          onClick={() => {
            setItems([]);
          }}
        />
      </When>
      {items.map((item, index) => (
        <PopupEffect key={item.key} component={item.component} triggerRect={item.triggerRect} positions={item.positions} zIndex={index + 10000} />
      ))}
    </div>
  );
}
